import { Spacing } from '@persona-id/design-tokens';
import { useContext } from 'react';
import { useController } from 'react-hook-form';
import styled from 'styled-components';

import { GraphDataContext } from 'dashboard/components/GraphModule/GraphDataWrapper';
import ReactSelect from 'dashboard/components/ReactSelect';
import Form from 'dashboard/layouts/FormLayout/Form';
import { QueryType } from 'dashboard/models/graph-query';
import { GraphQueryTemplate } from 'dashboard/models/graph-query-template';
import Button from 'design-system/components/Button';
import { useFormSecurely } from 'lib/security/reactHookForm';

export interface FormGraphQueryTemplateLoadData {
  graphQueryTemplateId: string;
}

interface FormGraphQueryTemplateLoadProps {
  onSubmit: (data: FormGraphQueryTemplateLoadData) => void;
}

const LoadButton = styled(Button)`
  width: 75px;
  display: inline-block;
  margin-top: ${Spacing[4]};
`;

const FormGraphQueryTemplateLoad = ({ onSubmit }: FormGraphQueryTemplateLoadProps) => {
  const { graphQueryTemplates: allGraphQueryTemplates } = useContext(GraphDataContext);
  // We don't support all graph query templates in this form
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const graphQueryTemplates = allGraphQueryTemplates.filter((gqt: GraphQueryTemplate) => {
    return [QueryType.ByCluster, QueryType.NHopsFromAccount].includes(gqt.attributes.type);
  });

  const { control, handleSubmit } = useFormSecurely();
  const {
    field: { onChange, value },
  } = useController({
    control,
    name: 'graphQueryTemplateId',
    defaultValue: {
      label: graphQueryTemplates[0]?.attributes?.name,
      value: graphQueryTemplates[0]?.id,
    },
  });

  const options = graphQueryTemplates.map((gqt: GraphQueryTemplate) => ({
    label: gqt.attributes.name,
    value: gqt.id,
  }));

  return (
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    <Form onSubmit={handleSubmit(onSubmit)}>
      <ReactSelect value={value} options={options} onChange={onChange} portal={true} />
      <LoadButton type='submit'>Load</LoadButton>
    </Form>
  );
};

export default FormGraphQueryTemplateLoad;
